import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';
import { dealItemsStreamingState } from '@/states/products.state';
import { useAtomValue } from 'jotai';
import { Loader2 } from 'lucide-react';

interface StreamingCountProps {
  count: ReactNode;
  className?: string;
}

/**
 * Affiche un compteur d'items, remplacé par un spinner tant que le stream
 * des deal items est en cours.
 */
export function StreamingCount({ count, className }: StreamingCountProps) {
  const isStreaming = useAtomValue(dealItemsStreamingState);
  if (!isStreaming) return <>{count}</>;
  return <Loader2 className={cn('h-3.5 w-3.5 animate-spin', className)} />;
}
